// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2iVsl","footer":"ModalFilter_footer__1HvC7"};